import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import logo from './assets/images/dariah-logo.png';
import Snow from 'react-snowfall'
import Calendar from './components/calendar';
function App() {
  return (
    <div className="App">
      <Snow snowflakeCount={400} color="#fff"/>
      <div className="calendar-background"></div>
      <div className="calendar-header">
        <img src={logo} alt="DARIAH logo" className="img-fluid"/>
      </div>
      <div className="container">
        <Calendar />
      </div>
    </div>
  );
}

export default App;
